import React, { useEffect, useRef, useState } from "react";
import "./subjectBox.css";
import SubjectBox from "./SubjectBox";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import { SubjectIcon } from "../../../SubjectIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SubjBoxProps = () => {
  const [variable, setVariable] = useState([]);
  const [isGettingData, setIsGettingData] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const userId = useSelector((state) => state.user?.currentUser?.id);

  const scrollContainerRef = useRef(null);

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflowing(container.scrollWidth > container.clientWidth);
    }
  };

  useEffect(() => {
    const handleResize = () => checkOverflow();
    // Delay checking to wait for DOM rendering
    const timer = setTimeout(() => checkOverflow(), 200);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [variable]);

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -500, behavior: "smooth" });
  };

  useEffect(() => {
    const helper = async () => {
      try {
        setIsGettingData(true);
        let response = await axios.get(
          `/homework/preRead/studentPreRead/studentSummary/get/studentId/${userId}`
        );
        response && setVariable(response.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsGettingData(false);
      }
    };
    helper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        className="publish_summery_container gap-3 mb-2 mt-2"
        style={{
          width: "100%",
          backgroundColor: "#f2f2f2",
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        {isOverflowing && (
          <button
            type="button"
            className="btn btn-light d-flex align-items-center justify-content-center shadow"
            onClick={scrollLeft}
            style={{
              position: "sticky",
              left: 0,
              zIndex: 10,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: "50%",
              backgroundColor: "#FDEFE3",
              width: "40px",
              height: "40px",
              border: "1px solid #4B4B4B",
            }}
          >
            <ChevronLeft color="#4B4B4B" size={24} />
          </button>
        )}
        {isGettingData ? (
          <img
            style={{ width: "80px", height: "70px", position: "sticky" }}
            className="ongoing_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        ) : (
          <div
            ref={scrollContainerRef}
            className="publish_summery_container mb-4 gap-3 flex overflow-x-auto relative "
            style={{
              scrollBehavior: "smooth",
              alignItems: "center",
            }}
          >
            {variable.map((obj) => (
              <div className="d-flex">
                <SubjectBox
                  subname={obj?.subject?.name}
                  sublogo={`${
                    SubjectIcon?.find(
                      (i) => i.subjectName === obj?.subject?.name
                    )?.icon || "/subIcon/ic_png_science.png"
                  }`}
                  notStarted={obj?.not_started}
                  complated={obj?.completed}
                />
              </div>
            ))}
          </div>
        )}

        {isOverflowing && (
          <button
            type="button"
            className="btn btn-light d-flex align-items-center justify-content-center shadow"
            onClick={scrollRight}
            style={{
              position: "sticky",
              right: 0,
              zIndex: 10,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: "50%",
              backgroundColor: "#FDEFE3",
              width: "40px",
              height: "40px",
              border: "1px solid #4B4B4B",
            }}
          >
            <ChevronRight color="#4B4B4B" size={24} />
          </button>
        )}
      </div>
      {/* {variable.length > 0 ? (
        <div className="d-flex gap-2">
          {variable.map((obj) => (
            <div className="d-flex">
              <SubjectBox
                subname={obj?.subject?.name}
                sublogo={`${SubjectIcon?.find((i) => i.subjectName === obj?.subject?.name)
                    ?.icon
                  }`}
                notStarted={obj?.not_started}
                complated={obj?.completed}
              />
            </div>
          ))}
        </div>
      ) : isGettingData ? (
        <img
          style={{ width: "80px", height: "70px" }}
          className="ongoing_loader"
          src="/gif/LoaderDot.gif"
          alt=""
        />
      ) : (
        <span>Subject Wise PreRead Not Found</span>
      )} */}
    </>
  );
};

export default SubjBoxProps;
